module.exports = __webpack_public_path__ + "assets/checkmark_outline-bc2b84.svg";